var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLFibLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5623_7927)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 12,
    fill: "#868EAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7252 54H19.6652V29.724H33.2312V32.41H22.7252V41.012H32.5852V43.698H22.7252V54ZM44.13 54H35.358V52.232L38.214 51.586V32.172L35.358 31.492V29.724H44.13V31.492L41.274 32.172V51.586L44.13 52.232V54ZM55.7535 29.724C57.7709 29.724 59.4595 29.9167 60.8195 30.302C62.2022 30.6873 63.2335 31.322 63.9135 32.206C64.6162 33.09 64.9675 34.2687 64.9675 35.742C64.9675 36.694 64.7862 37.544 64.4235 38.292C64.0835 39.0173 63.5622 39.6293 62.8595 40.128C62.1795 40.604 61.3409 40.9327 60.3435 41.114V41.284C61.3635 41.4427 62.2815 41.7373 63.0975 42.168C63.9362 42.5987 64.5935 43.2107 65.0695 44.004C65.5455 44.7973 65.7835 45.8287 65.7835 47.098C65.7835 48.5713 65.4435 49.8293 64.7635 50.872C64.0835 51.892 63.1089 52.674 61.8395 53.218C60.5929 53.7393 59.0969 54 57.3515 54H48.8175V29.724H55.7535ZM56.3655 40.06C58.4509 40.06 59.8789 39.7313 60.6495 39.074C61.4202 38.394 61.8055 37.3967 61.8055 36.082C61.8055 34.7447 61.3295 33.7927 60.3775 33.226C59.4482 32.6367 57.9522 32.342 55.8895 32.342H51.8775V40.06H56.3655ZM51.8775 42.61V51.416H56.7735C58.9269 51.416 60.4229 50.9967 61.2615 50.158C62.1002 49.3193 62.5195 48.22 62.5195 46.86C62.5195 45.9987 62.3269 45.2507 61.9415 44.616C61.5789 43.9813 60.9555 43.494 60.0715 43.154C59.2102 42.7913 58.0315 42.61 56.5355 42.61H51.8775Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5623_7927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLFibLogo);
export default __webpack_public_path__ + "static/media/L_FIB_Logo.9c5e2e4a157be083665f8d4b81501ecc.svg";
export { ForwardRef as ReactComponent };